import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Flex,
  Text,
  Badge,
} from '@chakra-ui/react';
import { GameInterface } from './GameInterface';
import type { CordeCommonModelsDtoMachineMachine, CordeCommonModelsDtoMachineGameSession } from '@/api';

interface GameModalProps {
  isOpen: boolean;
  onClose: () => void;
  machine: CordeCommonModelsDtoMachineMachine;
  session: CordeCommonModelsDtoMachineGameSession | null;
}

export const GameModal: React.FC<GameModalProps> = ({
  isOpen,
  onClose,
  machine,
  session,
}) => {
  const getStatusColor = (status?: string) => {
    switch (status) {
      case 'active':
        return 'green';
      case 'inactive':
        return 'red';
      case 'maintenance':
        return 'yellow';
      default:
        return 'gray';
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent maxH="90vh" bg="gray.900" color="white">
        <ModalHeader bg="gray.800" borderTopRadius="md">
          <Flex justify="space-between" align="center">
            <Box>
              <Text fontSize="lg" fontWeight="bold">
                🎰 {machine.name || 'Game Machine'}
              </Text>
              <Text fontSize="sm" color="gray.300">
                {machine.category || 'Casino Game'} • ID: {machine.id}
              </Text>
            </Box>
            <Badge
              colorScheme={getStatusColor(machine.status)}
              variant="solid"
              size="lg"
              px={3}
              py={1}
            >
              {machine.status?.toUpperCase() || 'UNKNOWN'}
            </Badge>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color="white" />
        
        <ModalBody p={6} overflowY="auto">
          {session ? (
            <GameInterface
              machineId={machine.id || ''}
              sessionId={session.id || ''}
              isActive={!!session}
            />
          ) : (
            <Box textAlign="center" py={12}>
              <Text fontSize="xl" mb={4}>
                🚫 No Active Game Session
              </Text>
              <Text color="gray.400">
                Please start a game session from the machine details page to begin playing.
              </Text>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}; 